function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M22.6685 14.5541C24.3547 14.5541 25.6974 15.847 25.6661 17.4868V20.2474C25.6661 23.0513 23.3931 25.3243 20.5892 25.3243C19.8882 25.3243 19.32 24.7561 19.3193 24.0551C19.3187 23.3672 19.3176 22.6792 19.3166 21.9913C19.3154 21.2134 19.3141 20.4355 19.3138 19.6576C19.3124 18.2771 19.3126 16.8965 19.3174 15.516C19.3188 15.1388 19.5313 14.7877 19.891 14.6741C20.0992 14.6085 20.3349 14.5541 20.5451 14.5541H22.6685Z",
  fill: "#303030"
}), React.createElement("path", {
  d: "M18.4115 13.9245V23.991C18.4115 24.7274 17.8146 25.3243 17.0782 25.3243H12.3333C9.38782 25.3243 7 22.9365 7 19.991V13.9277C7 13.7911 7.02454 13.6542 7.09473 13.537C7.60938 12.6775 9.00024 12.0196 9.59631 11.7685C9.77637 11.6927 9.97498 11.6816 10.1651 11.7265L10.4745 11.7996C10.9769 11.9183 11.3063 12.3999 11.2349 12.9112L10.6929 16.7917C10.6531 17.0766 10.8743 17.3308 11.1619 17.3308C11.4247 17.3308 11.6373 17.5449 11.6354 17.8078L11.634 18.0061C11.6313 18.3782 11.9322 18.6813 12.3043 18.6813H13.0875C13.4728 18.6813 13.7851 18.369 13.7851 17.9837V17.804C13.7851 17.5377 13.9916 17.3171 14.2573 17.2995C14.5503 17.28 14.7651 17.0158 14.7245 16.725L14.1887 12.8918C14.1148 12.3635 14.4688 11.8701 14.993 11.7709L15.2743 11.7176C15.4509 11.6841 15.6322 11.6981 15.7981 11.7673C16.3766 12.0084 17.7826 12.663 18.3123 13.5247C18.3856 13.644 18.4115 13.7844 18.4115 13.9245Z",
  fill: "#303030"
}), React.createElement("path", {
  d: "M15.4 8.65C15.4 10.1136 14.2135 11.3 12.75 11.3C11.2864 11.3 10.1 10.1136 10.1 8.65C10.1 7.18645 11.2864 6 12.75 6C14.2135 6 15.4 7.18645 15.4 8.65Z",
  fill: "#303030"
}), React.createElement("path", {
  d: "M24.3 10.65C24.3 12.1136 23.1136 13.3 21.65 13.3C20.1864 13.3 19 12.1136 19 10.65C19 9.18645 20.1864 8 21.65 8C23.1136 8 24.3 9.18645 24.3 10.65Z",
  fill: "#303030"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white",
  transform: "translate(0.333252)"
})));

var SvgLawFirm = function SvgLawFirm(props) {
  return React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,";
export { SvgLawFirm as ReactComponent };